import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/toast";
import axios from "axios";
import CustomButton from "../customButton/CustomButton";
let BASE_URL_FLORAHUB;
let BASE_URL_PAYMENT;

if (process.env.NODE_ENV === "production") {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_PAYMENT = process.env.REACT_APP_API_URL_PAYMENT;
} else {
  BASE_URL_FLORAHUB = process.env.REACT_APP_API_URL_FLORAHUB;
  BASE_URL_PAYMENT = process.env.REACT_APP_API_URL_PAYMENT;
}

const PaymentCard = ({
  orderId,
  isAddressSelect,
  reload,
  finalPriceData,
  addressData,
  originalPrice,
  paymentType,
}) => {
  const accessToken = localStorage.getItem("token");
  const navigate = useNavigate();
  const toast = useToast();
  const [finalPrice, setFinalPrice] = useState(0);
  const [finalDiscountPrice, setFinalDiscountPrice] = useState(0);
  const [finalWalletPrice, setFinalWalletPrice] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    // creating a new order
    // const result = await axios.post("http://localhost:5000/payment/orders");

    // if (!result) {
    //   alert("Server error. Are you online?");
    //   return;
    // }

    // Getting the order details back
    // const { amount, id: order_id, currency } = result.data;

    const options = {
      key: "rzp_test_ErKzta2msrgwiH", // Enter the Key ID generated from the Dashboard
      amount: "500".toString(),
      currency: "INR",
      name: "Wishfy Technologies Pvt. Ltd.",
      description: "Test Transaction",
      image: "https://placehold.co/400",
      order_id: "121211",
      handler: async function (response) {
        const data = {
          orderCreationId: "121211",
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
        };

        // const result = await axios.post(
        //   "http://localhost:5000/payment/success",
        //   data
        // );

        alert("Payment Success");
      },
      prefill: {
        name: "Deepak Singh",
        email: "deepak@wishfy",
        contact: "9999999999",
      },
      notes: {
        address: "Suite 202 Sector 63 Noida",
      },
      theme: {
        color: "#61dafb",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  async function calculateAmount(coupon = "string", isWalletUsed = false) {
    try {
      const response = await axios.post(
        `${BASE_URL_FLORAHUB}/order/api/v1/order/calculate/order/amount`,
        {
          isWalletUsed,
          offerCode: coupon,
          orderType: paymentType,
          orderId,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        console.log(response.data.payload);
        setFinalPrice(response.data.payload.totalPayAmount);
        setFinalDiscountPrice(response.data.payload.discountAmount);
        setTotalPrice(response.data.payload.itemTotalAmount);
        setFinalWalletPrice(response.data.payload.applicableWalletAmount);
        setDeliveryFee(response.data.payload.deliveryFee);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        console.log("404 Error");
      } else {
        console.log("Something went wrong");
      }
    }
  }

  async function placeOrder() {
    try {
      const response = await axios.post(
        `${BASE_URL_PAYMENT}/api/v1/do`,
        {
          orderId,
          amount:
            finalPriceData === null
              ? finalPrice
              : finalPriceData.totalPayAmount,
          paymentMode: "COD",
          orderType: "ecommerce",
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        localStorage.setItem("products", []);
        navigate("/Cart/OrderDetails", {
          state: { orderId: orderId },
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        console.log("404 Error");
      } else {
        console.log("Something went wrong");
      }
      toast({
        title: "Something went wrong!",
        status: "error",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
    }
  }

  useEffect(() => {
    calculateAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="sticky top-20 w-full   mt-10 bg-white border border-gray-200 rounded-lg shadow p-4">
      <div className="flex justify-between items-center text-sm ">
        <p>Original Price:</p>
        <p>{originalPrice}</p>
      </div>
      <div className="flex justify-between items-center text-sm ">
        <p>Discounted Price:</p>
        <p>
          {finalPriceData === null
            ? totalPrice
            : finalPriceData.itemTotalAmount}
        </p>
      </div>
      <div className="flex justify-between items-center  text-sm">
        <p>Coupon Discount:</p>
        <p className="text-green-600">
          {finalPriceData === null
            ? finalDiscountPrice
            : finalPriceData.discountAmount}
        </p>
      </div>
      <div className="flex justify-between items-center  text-sm">
        <p>Wallet Discount:</p>
        <p className="text-green-600">
          {finalPriceData === null
            ? finalWalletPrice
            : finalPriceData.applicableWalletAmount}
        </p>
      </div>
      <div className="flex justify-between items-center  text-sm">
        <p>Delivery Fee:</p>
        <p className="text-red-600">
          {finalPriceData === null ? deliveryFee : finalPriceData.deliveryFee}
        </p>
      </div>

      <hr className="my-2" />

      <div className="flex justify-between items-start my-2 font-semibold ">
        <div>
          <p className="text-left">Total:</p>
          <p className="text-xs text-gray-400">*(inc. of all taxes)</p>
        </div>
        <p>
          {finalPriceData === null ? finalPrice : finalPriceData.totalPayAmount}
        </p>
      </div>

      {isAddressSelect === false && (
        <div className="mt-4 w-100 ">
          <CustomButton className="w-full my-5 !bg-[#372449]" disabled={true}>
            Please Choose Address
          </CustomButton>
        </div>
      )}

      {isAddressSelect === true && (
        <div className="mt-4 w-100 ">
          <CustomButton
            className="mx-auto w-1/2 my-5 !bg-[#372449]"
            onClick={async () => {
              if (paymentType === "CART") {
                await placeOrder();
              } else {
                //Implement Razorpay once API comes
                // await displayRazorpay();
              }
            }}
            disabled={addressData.length === 0}
          >
            {addressData.length === 0
              ? "Please Add Address"
              : paymentType === "PAY_ONLINE"
              ? "Pay Online"
              : "Confirm Order"}
          </CustomButton>
        </div>
      )}

      <div className="text-left mt-2 text-xl text-[#31a05e] font-semibold text-normal">
        <p>
          Your total saving on this order is ₹
          {finalPriceData === null
            ? finalDiscountPrice + finalWalletPrice
            : originalPrice -
              finalPriceData.itemTotalAmount +
              finalPriceData.discountAmount +
              finalPriceData.applicableWalletAmount}
        </p>
      </div>
    </div>
  );
};

export default PaymentCard;
